// 项目权限编码从这里开始
export const AuthProjectCodeStart = 1000;

// 权限编码
export enum AuthMenuCode {
    AUTH = 0,// 权限设置
    PURCHASE = 1,   // 采购
    OUTBOUND = 2,   // 出库
    INBOUND = 3,   // 入库
    SCRAP = 4,// 报废

    ORGANIZATION = 5, // 组织
    CONTACT = 6, // 联系人
    SOFTWARE = 7, // 软件
    ACCOUNT = 8,// 账号
    QUALITY = 9,// 资信
    CONCEPT = 10,// 概念
    BOOK = 11,// 图书
    PAPER = 12,// 论文
    COURSE = 13,// 课程

    RULE = 14,// 制度
    POSITION = 15,// 职位
    QUOTA = 16,// 定额
    // STRUCTURE = 17,// 结构
    // ENGINEERING = 18,// 工程
    // SOFTWARE_STANDARD = 19,// 软件
    // HARDWARE_STANDARD = 20,// 硬件
    // PROJECT_MANAGE = 21,// 项目管理
    // AI_STANDARD = 22,// AI标准

    OFFICE_DEVICE = 23,// 办公设备
    ENGINEERING_DEVICE = 24,// 工程设备
    CONSUMABLE = 25,// 耗材
    GIFT = 26,// 礼品

    UI_COMPONENT = 27,// ui组件
    DEV_COMPONENT = 28,// 开发组件
    API = 29,// api
    ALGORITHM = 30,// 算法
    PROJECT = 31,// 项目
    STANDARD = 32, // 标准

    EXPERIENCE = 33,// 经验

    REPORT = AuthProjectCodeStart,  // 报告
    FILE, // 文件
    BUDGET,// 预算
    PLAN,// 计划
    WBS,// wbs
    QUOTATION,//报价单
    BRIEFING, // 汇报
    PERFORMANCE, // 绩效

}

export enum AuthCategory {
    ALL = -1,   // 全部
    READ = 1,   // 查增删改
    CREATE = 2,
    DELETE = 3,
    UPDATE = 4,
    UPLOAD = 5,
    DOWNLOAD = 6,
    NEW_FOLDER = 7,
    DELETE_FILE = 8,
    COPY_FILE = 9,
    RENAME_FILE = 10,
    EDIT_TASK = 11,
    PUBLISH_TASK = 12,
    DELETE_TASK = 13,
    ADD_DISCUSS_RECORD = 14,
    EDIT_DISCUSS_RECORD = 15,
    DELETE_DISCUSS_RECORD = 16,
    SHOW_PASSWORD = 17,
    SHARE_FILE = 18,
}

export const AuthProjectCategoryList = [
    AuthCategory.ALL,
    AuthCategory.READ,
    AuthCategory.CREATE,
    AuthCategory.DOWNLOAD,
    AuthCategory.NEW_FOLDER,
    AuthCategory.SHARE_FILE,
    AuthCategory.DELETE_FILE,
    AuthCategory.COPY_FILE,
    AuthCategory.RENAME_FILE,
    AuthCategory.EDIT_TASK,
    AuthCategory.PUBLISH_TASK,
    AuthCategory.DELETE_TASK,
]

export const AuthLibraryCategoryList = [
    AuthCategory.ALL,
    AuthCategory.READ,
    AuthCategory.CREATE,
    AuthCategory.DELETE,
    AuthCategory.UPDATE,
    AuthCategory.UPLOAD,
    AuthCategory.DOWNLOAD,
    AuthCategory.ADD_DISCUSS_RECORD,
    AuthCategory.EDIT_DISCUSS_RECORD,
    AuthCategory.DELETE_DISCUSS_RECORD,
    AuthCategory.SHOW_PASSWORD,
]

export const AuthMenuMap = {
    [AuthMenuCode.PURCHASE]: '采购',
    [AuthMenuCode.OUTBOUND]: '出库',
    [AuthMenuCode.INBOUND]: '入库',
    [AuthMenuCode.SCRAP]: '报废',

    [AuthMenuCode.ORGANIZATION]: '组织',
    [AuthMenuCode.CONTACT]: '联系人',
    [AuthMenuCode.SOFTWARE]: '软件',
    [AuthMenuCode.ACCOUNT]: '账号',
    [AuthMenuCode.QUALITY]: '资信',
    [AuthMenuCode.CONCEPT]: '概念',
    [AuthMenuCode.BOOK]: '图书',
    [AuthMenuCode.PAPER]: '论文',
    [AuthMenuCode.EXPERIENCE]: '经验',
    [AuthMenuCode.COURSE]: '课程',

    [AuthMenuCode.RULE]: '制度',
    [AuthMenuCode.POSITION]: '职位',
    [AuthMenuCode.QUOTA]: '定额',
    // [AuthMenuCode.STRUCTURE]: '结构',
    // [AuthMenuCode.ENGINEERING]: '工程',
    // [AuthMenuCode.SOFTWARE_STANDARD]: '软件标准',
    // [AuthMenuCode.HARDWARE_STANDARD]: '硬件标准',
    // [AuthMenuCode.PROJECT_MANAGE]: '项目管理',
    // [AuthMenuCode.AI_STANDARD]: 'AI标准',

    [AuthMenuCode.OFFICE_DEVICE]: '办公设备',
    [AuthMenuCode.ENGINEERING_DEVICE]: '工程设备',
    [AuthMenuCode.CONSUMABLE]: '耗材',
    [AuthMenuCode.GIFT]: '礼品',

    [AuthMenuCode.UI_COMPONENT]: 'UI组件',
    [AuthMenuCode.DEV_COMPONENT]: '开发组件',
    [AuthMenuCode.API]: 'API',
    [AuthMenuCode.ALGORITHM]: '算法',
    [AuthMenuCode.PROJECT]: '项目',

    [AuthMenuCode.AUTH]: '权限设置',

    [AuthMenuCode.REPORT]: '报告',
    [AuthMenuCode.FILE]: '文件',
    [AuthMenuCode.BUDGET]: '预算',
    [AuthMenuCode.PLAN]: '计划',
    [AuthMenuCode.WBS]: '任务管理',
    [AuthMenuCode.QUOTATION]: '报价',

    [AuthMenuCode.STANDARD]: '标准',
    [AuthMenuCode.BRIEFING]: '汇报',
    [AuthMenuCode.PERFORMANCE]: '绩效评估',
}

export const AuthCategoryMap = {
    [AuthCategory.ALL]: '全部',
    [AuthCategory.READ]: '查看',
    [AuthCategory.CREATE]: '新增',
    [AuthCategory.UPDATE]: '修改',
    [AuthCategory.DELETE]: '删除',
    [AuthCategory.UPLOAD]: '上传文件',
    [AuthCategory.DOWNLOAD]: '下载文件',
    [AuthCategory.NEW_FOLDER]: '新建文件夹',
    [AuthCategory.SHARE_FILE]: '分享文件',
    [AuthCategory.DELETE_FILE]: '删除文件',
    [AuthCategory.COPY_FILE]: '复制文件',
    [AuthCategory.RENAME_FILE]: '重命名文件',
    // [AuthCategory.NEW_PACKAGE]: '新建任务包',
    // [AuthCategory.DELETE_PACKAGE]: '删除任务包',
    [AuthCategory.EDIT_TASK]: '编辑任务',
    [AuthCategory.PUBLISH_TASK]: '发布任务',
    [AuthCategory.DELETE_TASK]: '删除任务',
    [AuthCategory.ADD_DISCUSS_RECORD]: "添加讨论",
    [AuthCategory.EDIT_DISCUSS_RECORD]: "编辑讨论",
    [AuthCategory.DELETE_DISCUSS_RECORD]: "删除讨论",
    [AuthCategory.SHOW_PASSWORD]: "查看密码"
}